<app-bookme-banner>
  <ng-container banner-header-content>
    @if (existingMeeting) {
    <div class="duration-and-location">
      <span class="duration">
        <div class="meeting-time-change">
          <mat-icon>watch_later</mat-icon>
          <span data-testid="meeting-length">
            {{
              existingMeeting.startTime
                | date : 'h:mm a' : (timezoneOffset$ | async)
            }}
            -
            {{
              existingMeeting.endTime
                | date : 'h:mm a' : (timezoneOffset$ | async)
            }}
            {{ existingMeeting.startTime | date : 'EEE, dd MMM YYYY' }}
          </span>
        </div>
      </span>
    </div>
    } @else {
    <div class="duration-and-location">
      <span class="duration">
        <mat-icon>watch_later</mat-icon>
        <span data-testid="meeting-duration">
          {{ meetingMinuteDuration$ | async }}
        </span>
        <span
          data-testid="meeting-minutes"
          i18n="@@CALENDAR.MEETING_INFO.MINUTES"
        >
          minutes
        </span>
      </span>
    </div>
    }
  </ng-container>

  <ng-container banner-location-information>
    @if ((existingMeeting ? location$ : inPersonLocation$) | async; as location)
    {
    <span class="in-person-location">
      <mat-icon>location_on</mat-icon>
      <span
        data-testid="meeting-location"
        [matTooltip]="location"
        matTooltipShowDelay="500"
        [class.truncated]="location.length > 90"
      >
        {{
          location.length > 90 ? (location | slice : 0 : 90) + '...' : location
        }}
      </span>
    </span>
    }
  </ng-container>

  @if (meetingDescription$ | async; as meetingDescription) {
  <div banner-header-description class="description">
    <app-expandable-text
      [trim]="(isMobile$ | async) ?? false"
      [text]="meetingDescription"
      [matTooltip]="meetingDescription"
      matTooltipPosition="below"
    >
    </app-expandable-text>
  </div>
  }
</app-bookme-banner>
